import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'react-bootstrap';
import { isPresent } from 'helpers/string_helpers';

export default class SelectContacts extends React.Component {
  static propTypes = {
    contacts: PropTypes.array.isRequired,
    selectedContacts: PropTypes.array.isRequired,
    totalCount: PropTypes.number.isRequired,
    onSelectAll: PropTypes.func.isRequired,
    onSelectContact: PropTypes.func.isRequired
  }

  render() {
    return (
      <Table>
        <thead>
          {this.renderHeaderColumns()}
        </thead>
        <tbody>
          {this.renderTableContent()}
        </tbody>
      </Table>
    );
  }

  renderHeaderColumns() {
    const { selectedContacts, totalCount, onSelectAll } = this.props;

    return (
      <tr>
        <td>
          <input
            checked={selectedContacts.length >= totalCount}
            type="checkbox"
            onChange={onSelectAll}
          />
        </td>
        <td>First Name</td>
        <td>Last Name</td>
        <td>Email Addresses</td>
        <td>Phone Numbers</td>
      </tr>
    );
  }

  renderTableContent() {
    const { contacts, selectedContacts, onSelectContact } = this.props;

    if (contacts.length == 0) {
      return (
        <div className="text-center text-bold">No Results Found.</div>
      );
    } else {
      return contacts.map((contact) => {
        return (
          <tr key={contact.id}>
            <td>
              <input
                checked={selectedContacts.some(id => id === contact.id)}
                type="checkbox"
                value={contact.id}
                onChange={onSelectContact}
              />
            </td>
            <td>{contact.firstName}</td>
            <td>{contact.lastName}</td>
            <td>{this.renderEmails(contact.emailAddresses)}</td>
            <td>{this.renderNumbers(contact.phoneNumbers)}</td>
          </tr>
        );
      });
    }
  }

  renderEmails(emailAddresses = []) {
    return emailAddresses.map((email) => {
      const key = `${email.label}:${email.email}`;
      const label = isPresent(email.label) ? <strong>{email.label}: </strong> : null;

      return (
        <div key={key}>{label}{email.email}</div>
      );
    });
  }

  renderNumbers(phoneNumbers = []) {
    return phoneNumbers.map((number) => {
      const label = isPresent(number.label) ? <strong>{number.label}: </strong> : null;

      return (
        <div key={number.label + number.number}>{label}{number.number}</div>
      );
    });
  }
}